import styled from 'styled-components';
import { makeStyles } from '@material-ui/core';

import { SmallSectionHeader } from 'components/Typography';

const useStyles = makeStyles({
  root: {
    fontSize: '11px !important',
    width: '83px !important',
    borderRadius: '6px',
    color: '#285BC7 !important',
    border: '1px solid #FFFFFF !important',
    '&:hover': {
      color: '#285BC7 !important',
    },
  },
});

const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  margin-bottom: 16px !important;
`;
export { useStyles, StyledSmallSectionHeader };
